import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { VisitorSignIn, Section, Heading, Label, Value, PaddedContent, general } from 'daymap-library';
import { useVisitor } from '../visitorContext';
import { useAuth } from '../../../helpers/authContext';
import Alert, { ALERT_TYPE } from '../../../components/Alert/Alert';

const SignIn = () => {
    const [savedVisitor, setSavedVisitor] = useState(null);
    const [complete, setComplete] = useState(false);
    const [bytes, setBytes] = useState(null);
    const { visitorSettings } = useVisitor();
    const { lmsFetch } = useAuth();

    const visitorSearchHandler = async (searchText) => {
        const [getVisitors] = lmsFetch(`/lms/api/checkin/visitors/search?searchTerm=${searchText}`);
        const response = await getVisitors();

        return response;
    }

    const staffSearchHandler = async (searchText) => {
        const [getStaff] = lmsFetch(`/lms/api/checkin/visitors/staff?searchTerm=${searchText}`);
        const response = await getStaff();

        response.data = response.data.map(s => { return { ...s, Name: `${s.Firstname} ${s.Surname}`} })
        return response;
    }

    const saveHandler = async (visitor) => {
        const [save] = lmsFetch(`/lms/api/checkin/visitors/save`, visitor);
        const response = await save();

        setSavedVisitor(response.data);

        return response;
    }

    const visitorImageHandler = async (visitId, blobUrl) => {
        var reader = new FileReader();
        let blobObj = await fetch(blobUrl).then(res => res.blob())
        reader.readAsDataURL(blobObj); 
        reader.onloadend = async function(){
            var base64data = reader.result;                
            var data = {filename: 'visitorImage', visitID: visitId, filedata: base64data};
            const [save] = lmsFetch(`/lms/api/checkin/visitors/image`, data);

            const response = await save();
        }
      }

    const signInComplete = () => {
        setComplete(true);
    }
    
    const getBytes = async () => {
        if(visitorSettings.TsAndCsAttachmentId){
            const config = {returns:"raw"};
            const [bytes] = lmsFetch("/lms/api/files/file/" + visitorSettings.TsAndCsAttachmentId, null, config);
            const response = await bytes();
            response.arrayBuffer().then((buffer) => {
                setBytes(new Int8Array(buffer));}
               
                );
        }
    }

    useEffect(() => {
        getBytes();
    }, [visitorSettings])

    if (!visitorSettings)
        return <></>

    if (complete && savedVisitor)
        return <SignInConfirmation visitor={savedVisitor} />
    return <VisitorSignIn settings={{...visitorSettings,TsAndCsAttachmentBytes:bytes}} getVisitorsByName={visitorSearchHandler} getSearchResults={staffSearchHandler} saveVisitor={saveHandler} signInComplete={signInComplete} schoolName = "" visitorImageHandler={visitorImageHandler} />
}

const SignInConfirmation = ({visitor}) => {
    const { settings } = useAuth();
    const navigate = useNavigate();
    const [ secondsTilRedirect ] = general.useCountdown({ seconds: settings.KioskRedirectDelay, onZero: () => navigate('/visitors') });

    if(!(settings.KioskRedirectDelay > 0))
    {
        navigate('/visitors');
        return "";
    }
    

    return <Section>
        <Heading>Visitor Details</Heading>
        <PaddedContent>
            <Label position="Top" text="Name">
                <Value>{visitor.Firstname} {visitor.Surname}</Value>
            </Label>
            <Label position="Top" text="Mobile">
                <Value>{visitor.Company}</Value>
            </Label>
            <Label position="Top" text="Purpose">
                <Value>{visitor.Purpose}</Value>
            </Label>
            <Label position="Top" text="Whom Visiting">
                <Value>{visitor.WhomVisiting}</Value>
            </Label>
            <Alert type={ALERT_TYPE.Success} heading="Sign In Complete">
                Returning to Visitor home page in {secondsTilRedirect} seconds.
            </Alert>
        </PaddedContent>
    </Section>
}

export default SignIn;